const {
  Modal,
} = window.jesuitsFramework;

export default function initSearchModal() {
  const buttons = document.querySelectorAll('.js-search-modal-trigger');
  if (!buttons) return;

  const modalContent = document.getElementById('search-modal');
  if (!modalContent) return;

  const searchInput = modalContent.querySelector('[name=s]');
  const modalManager = new Modal();

  Array.prototype.slice.call(buttons).forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      modalManager.open(modalContent);
      searchInput.focus();
    });
  });
}
